<template>
    <asli-form @submitted="goBack">
        <asli-quote-declined
            title="We're sorry, but we are unable to complete your quote online."
            icon="personWithHeadset"
        >
            <p class="text-center text-lg">
                If you can't get a quote online, we may be able to provide you with a quote over the phone, please
                <span class="font-bold">call us</span> with reference number,
                <span class="font-bold"> {{ quote?.reference }}</span> on
                <a class="font-bold text-primary" :href="`tel:${BRAND_PHONE_NUMBER}`">{{ BRAND_PHONE_NUMBER }}</a
                >.
            </p>
        </asli-quote-declined>
        <asli-divider class="mt-[30px]" />
        <div class="flex flex-col items-center md:items-start">
            <form-buttons
                :showBack="false"
                :continue-button-title="isOfflineQuote ? 'Back' : 'Back to Quote Details'"
            />
        </div>
    </asli-form>
</template>

<script lang="ts" setup>
import { computed, nextTick } from "vue";
import { useRouter } from "vue-router";
import FormButtons from "@/components/FormButtons.vue";
import { BRAND_PHONE_NUMBER } from "@/static/constants";
import { AsliDivider, AsliQuoteDeclined, AsliForm } from "@mbs-npm/anpost-ui";
import { useProposalStore } from "@/stores/risk/risk";
import { useMainStore } from "@/stores/main";
import useNavigationHelpers from "@/router/helpers";

const router = useRouter();
const proposalStore = useProposalStore();
const mainStore = useMainStore();
const { goToPreviouslyRecordedRoute } = useNavigationHelpers();

const quote = computed(() => proposalStore?.proposal?.quote);
const isOfflineQuote = computed(() => proposalStore.proposal?.recalled_from_offline);

const prevRoute = mainStore.previousRoute;

async function goBack() {
    if (mainStore.resetQuote && !quote.value.is_quoted) {
        await proposalStore.resetQuote();
    } else {
        if (prevRoute?.fullPath) {
            router.push(prevRoute.fullPath);
        }
        return;
    }
    mainStore.stopNavigation = false;
    nextTick(() => {
        goToPreviouslyRecordedRoute();
    });
}
</script>
